<div class="dialog-container">
  <!-- Transparent hole -->
  <div class="spotlight-hole" [ngStyle]="{
      top: (data.top - 10) + 'px',
      left: (data.left - 10) + 'px',
      width: (data.width + 20)+ 'px',
      height: (data.height + 20) + 'px'
    }"></div>

  <!-- Popup Box -->
  <div class="popup-box" [style.top.px]="data.top + 55" [style.left.px]="data.left - 10">

    <div class="tooltip-header">
      <h3>👋 Almost There — Let’s Get Your Employees Onboard</h3>
      <span class="material-symbols-outlined" (click)="closeTooltip()">close</span>
    </div>
    <div class="tooltip-content">
      <p>Please check the installation guide to complete the setup.</p>
      <div class="content-list">
        <p>⚙️ Quick Fixes to Install Agent</p>
        <ol>
          <li>⬇️ Install Agent & Guide
            <br>
            <span>Go to Employees List → Actions → Download, then install using admin rights.</span>
          </li>
          <li>⏰ System Date & Time
            <br>
            <span>Ensure the system's date & time are accurate.</span>
          </li>
          <li>🛡️ Antivirus Tip (install only)
            <br>
            <span>Some Antivirus software quarantines SuperSee during install. Pause Antivirus briefly, install, then turn Antivirus back on.</span>
            <span>After setup, SuperSee usually runs fine with Antivirus on. Restart the system after install.</span>
          </li>
          <li>🖥️ Installing on a PC with Multiple User Profiles?
            <br>
            <span>Setup may differ. <a target="_blank" rel="noopener"
                href="https://api.whatsapp.com/send?phone=916354719703&text=Hi,%20I%20got%20this%20number%20from%20SuperSee%20Integration">Contact
                Support</a> for help.</span>
          </li>
        </ol>
      </div>
    </div>
    <div class="btns">
      <p>🛠️ Still facing an issue?</p>
      <button class="guide" (click)="goToHelpAndSupportPage()">📘 Visit Help & Support</button>
    </div>
  </div>
</div>